import React from "react";
import OtpContainer from "../../containers/Auth/Otp";

export default function LoginPage() {
  return <OtpContainer />;
}
